import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import UserStats from '../components/UserStats/UserStats';

export const userStatRoutes = (
  <Route path="/user_stats" element={<MainLayout />}>
    <Route path="user_stats" element={<UserStats />} />
  </Route>
);
